import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AdvancedTagMappingPopupDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paperWidthLg': {
    maxWidth: '1200px!important',
    width: '1200px',
  },
}));
